module.exports = __webpack_public_path__ + "static/video1-e36e7ac08a2d344a5f25e9575f39a90c.mp4";